(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vivid-buying-guide-case"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vivid-buying-guide')) {
  customElements.define('vivid-buying-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.mount(), { once: true, signal: this.controller.signal });
      else this.mount();
    }
    disconnectedCallback() { this.controller?.abort(); this.mounted = false; }
    mount() {
      if (!this.isConnected || this.mounted) return;
      this.tabs = [...this.querySelectorAll('[data-guide-tab]')];
      this.panels = [...this.querySelectorAll('[data-guide-panel]')];
      if (!this.tabs.length || !this.panels.length) return;
      this.mounted = true;
      const tablist = this.querySelector('[data-guide-tabs]');
      tablist.setAttribute('role', 'tablist');
      this.tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      this.panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.guideTab === panel.dataset.guidePanel).id); });
      this.setSection(this.tabs[0]);
      this.querySelectorAll('[data-guide-comparison]').forEach(comparison => this.setVersion(comparison, 'after'));
      this.querySelectorAll('[data-guide-controls]').forEach(control => { control.hidden = false; });
      tablist.hidden = false;
      this.classList.add('is-enhanced');
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-guide-tab]');
        if (tab && this.contains(tab)) this.setSection(tab);
        const version = event.target.closest('[data-guide-version]');
        if (version && this.contains(version)) this.setVersion(version.closest('[data-guide-comparison]'), version.dataset.guideVersion);
        const zoom = event.target.closest('[data-guide-zoom]');
        if (zoom && this.contains(zoom)) {
          const comparison = zoom.closest('[data-guide-comparison]');
          comparison.classList.toggle('is-fit', zoom.dataset.guideZoom === 'fit');
          comparison.querySelectorAll('[data-guide-zoom]').forEach(button => button.setAttribute('aria-pressed', String(button === zoom)));
        }
      }, { signal: this.controller.signal });
      tablist.addEventListener('keydown', event => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); this.setSection(this.tabs[next]); this.tabs[next].focus();
      }, { signal: this.controller.signal });
    }
    setSection(selected) {
      this.tabs.forEach(tab => { const active = tab === selected; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.guidePanel !== selected.dataset.guideTab; });
    }
    setVersion(comparison, selected) {
      comparison.querySelectorAll('[data-guide-version]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideVersion === selected)));
      comparison.querySelectorAll('[data-guide-state]').forEach(figure => { figure.hidden = figure.dataset.guideState !== selected; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
